import clienteAxios from "../config/axios";

export async function verifyLicense(){
    return clienteAxios.get('/license/verify');
}